import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import axios from "axios";
import { API } from "@/lib/auth";

// Cache module-scope para no repetir la llamada en cada re-render.
let cachedPromise = null;
const fetchConfig = () => {
  if (!cachedPromise) {
    cachedPromise = axios
      .get(`${API}/public/config`)
      .then((r) => r.data || {})
      .catch(() => ({}));
  }
  return cachedPromise;
};

/**
 * Botón "Descargar manual" para el alumno.
 * - Se conecta a `/api/public/config` para saber si hay manual configurado.
 * - Si `MANUAL_URL` no está en `.env`, el botón NO se renderiza (silencioso).
 * - Abre el PDF en pestaña nueva (`target="_blank"` + rel de seguridad).
 * - Se puede reutilizar en varias pantallas del alumno.
 */
export function DownloadManualButton({
  className = "",
  testid = "download-manual-btn",
  size = "default",
  label = "DESCARGAR MANUAL",
  variant = "outline",
}) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let cancelled = false;
    fetchConfig().then((cfg) => {
      if (!cancelled) setUrl(cfg.manual_url || null);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!url) return null;
  return (
    <Button
      asChild
      variant={variant}
      size={size}
      className={`border-2 border-zinc-900 hover:bg-zinc-950 hover:text-white font-bold tracking-wide transition-colors ${className}`}
      data-testid={testid}
    >
      <a href={url} target="_blank" rel="noopener noreferrer">
        <Download className="h-4 w-4 mr-2" />
        {label}
      </a>
    </Button>
  );
}
